import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getRoles() {
  try {
    const resp = await axios.get(`/api/role/?pageSize=1000`);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
